export default "__VITE_ASSET__CO2o_G2H__"